module.exports = "<H1>Über uns</H1>\n\n\n<H2>Hersteller des Programms Lagerinfo:</H2>\n\n<p>Sowentus Software Engineering Schlestein Ltd<br>ZweigNL Eppingen<br>Goethestr. 26<br>75031 Eppingen</p>\n<p></p>\n<p>Tel: 07262 601 07 07 (Support)<br>\nFax: 07262 601 07 08</p>\n<p>Internet: www.sowentus.de</p>\n<p>EMail: info@sowentus.de</p>\n\n<H3>Hinweis: Das Programm zeigt die aktuellen Lagerbestände mit einer Verzögerung von max. 30 Minuten!</H3>"


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = 1